<script>
  import CashflowMCalculator from "./components/CashflowMCalculator.svelte";
  import CashflowMExplanation from "./components/CashflowMExplanation.svelte";
  import { setupI18n, changeLocale, _ } from "../../../../helpers/i18n.js";
  import { globalStore } from "../store/globalStore";
  import { setupPageTracking } from '../../helpers/analytics.js';

  const urlParams = new URLSearchParams(window.location.search);
  const paramCountry = urlParams.get('country') ?? 'cl';

  setupPageTracking('cashflow_monthly');

  const i18nSetup = setupI18n(paramCountry);

  const { country, isMobile } = globalStore;

  // Reaccionar a cambios en el país del globalStore
  $: if ($country) {
    changeLocale($country);
  }

  $: explanationIcon = $isMobile ? '/icons/explanation_mobile.svg' : '/icons/explanation.svg';
</script>

{#await i18nSetup then}
<div class="calculator-header">
  <div class="calculator-header__wrapper">
    <h1 class="calculator-title">
      {$_("cashflowMonthly.calculation.title")}
    </h1>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <img src={explanationIcon} alt="Conoce más." title="Conoce más." class="help-icon" on:click={() =>document.getElementById("explanation").scrollIntoView({ behavior: "smooth" })}/>
  </div>
</div>
<div class="main-content">

  <CashflowMCalculator />
</div>

<div class="explanation-content" id="explanation">
  <CashflowMExplanation />
</div>
{/await}
